/**
 * The Terms of Service body: `src/content/legal/terms-of-service.md` rendered
 * to HTML. The decisions behind the text are recorded in
 * `goodsender-autopilot/specs/directory-compliance/DECISIONS.md`.
 *
 * Imported from the `/terms` route's component alone, never from
 * `terms-seo.ts`, so markdown-it and the terms text travel in the `/terms`
 * chunk rather than the entry chunk (same split as `privacy-policy.ts`).
 */

import termsMarkdown from "@/content/legal/terms-of-service.md?raw";
import { legalLastUpdated, renderLegalMarkdown } from "@/lib/legal-markdown";

/**
 * The terms' "Last updated: Month D, YYYY" line as YYYY-MM-DD.
 * `terms-of-service-page.test.ts` asserts the result equals
 * `TERMS_LAST_UPDATED` in `terms-seo.ts`.
 */
export function termsLastUpdated(markdown: string): string {
  return legalLastUpdated(markdown, "terms-of-service.md");
}

let cached: string | undefined;

/** The terms as HTML, rendered once per process: the source is a static file. */
export function renderTermsOfServiceHtml(): string {
  cached ??= renderLegalMarkdown(termsMarkdown);
  return cached;
}
